import { render, staticRenderFns } from "./AddPrize.vue?vue&type=template&id=0a200f7b&scoped=true"
import script from "./AddPrize.vue?vue&type=script&lang=js"
export * from "./AddPrize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a200f7b",
  null
  
)

export default component.exports